export const CLASSES = {
  LABEL: 'label',
  TITLE: 'title',
  VALUE: 'value',
  TOGGLE: 'toggle',
  OPTION: 'option',
  WRAPPER: 'wrapper',
  SELECTED: 'selected',
  X_AXIS: 'x-axis',
  NODE: 'node',
  AREA: 'area',
  AVERAGES: 'averages',
  LEGEND: 'legend',
  SLIDE: 'slide',
  CONTROL: 'control',
  TREATMENT: 'treatment',
  CIRCLE: 'circle',
  ARROW: 'arrow',
  NARROW: 'narrow',
  RIGHT: 'right',
  LEFT: 'left',
  GRADIENT: 'gradient',
  CARD: 'card',
  TEXTBOX: 'textbox',
  VIZ: 'viz',
  ROW: 'row',
  GROUP: 'group',
  TRIANGLE: 'triangle',
  FILTER: 'filter',
  OPEN: 'open',
  CONTAINER: 'container',
  STEP: 'step',
  BACKGROUND: 'background',
  DIFF: 'diff',
  BOTTOM: 'bottom',
  TOP: 'top',
  POLAR: 'polar',
  ITEM: 'item',
  LINE: 'line',
  PARTY: 'party'
};

export const COLORS = {
  red: "#9B2226",
  blue: "#000F5C",
  champagne: "#E9D8A6",
  green: "#A9DBCA",
  neutral: "#1F1C21",
  neutralLight: "#D6D7D9"
}

export const COLUMN_KEYS = {
  IMP_DOM: "pass_important_dom",
  SPR_DOM: "pass_spread_dom",
  NOR_DOM: "pass_normalcy_dom",
  LIM_DOM: "pass_limit_dom",
  UNF_DOM: "pass_unfair_dom",
  PRI_DOM: "pass_privacy_dom",
  IMP_INTER: "pass_important_inter",
  SPR_INTER: "pass_spred_inter",
  NOR_INTER: "pass_normalcy_inter",
  LIM_INTER: "pass_limit_inter",
  UNF_INTER: "pass_unfar_inter",
  PRI_INTER: "pass_privacy_inter",
}

export const COLUMN_KEYS_SQ_OVERRIDES = {
  [COLUMN_KEYS.SPR_INTER]: "pass_spread_interSQ",
  [COLUMN_KEYS.UNF_INTER]: "pass_unfair_interSQ"
}

export const COLUMNS = Object.values(COLUMN_KEYS)

export const COLUMN_LABELS = {
  [COLUMN_KEYS.IMP_DOM]: "Domestic Pass Importance",
  [COLUMN_KEYS.SPR_DOM]: "Domestic Pass Spread",
  [COLUMN_KEYS.NOR_DOM]: "Domestic Pass Helps Normalcy",
  [COLUMN_KEYS.LIM_DOM]: "Domestic Pass Limits Liberties",
  [COLUMN_KEYS.UNF_DOM]: "Domestic Pass is Unfair",
  [COLUMN_KEYS.PRI_DOM]: "Domestic Pass Privacy Concerns",
  [COLUMN_KEYS.IMP_INTER]: "International Pass Importance",
  [COLUMN_KEYS.SPR_INTER]: "International Pass Spread",
  [COLUMN_KEYS.NOR_INTER]: "International Pass Helps Normalcy",
  [COLUMN_KEYS.LIM_INTER]: "International Pass Limits Liberties",
  [COLUMN_KEYS.UNF_INTER]: "International Pass is Unfair",
  [COLUMN_KEYS.PRI_INTER]: "International Pass Privacy Concerns",
}

export const SLIDE_METRICS = [
  {
    name: 'domestic',
    control: 'domestic mean',
    treatment: 'domestic sq mean',
  },
  {
    name: 'international',
    control: 'international mean',
    treatment: 'international sq mean',
  },
];

export const TOGGLE_VALS = [{ text: "control", val: false }, { text: "treatment", val: true }]

export const CONFIG = {
  COLOR_RANGE: [COLORS.red, COLORS.blue],
  COLOR_DOMAIN: ["Republican", "Democrat"],
  X_DOMAIN: ["Less Agreement", "More Agreement"],
  DIMS: {
    width: 600,
    height: 500,
    margin: { x: 20, y: 50 }
  },
  DURATION: 1500,
  DELAY: 1000,
  TIME_SHT: 250,
  RADIUS: 3.5,
  TRIANGLE_SIZE: 100
};

export const SPACING = {
  axisHeight: 22,
  ySpaceMultiplier: 10,
  linePadding: 10,
  dotPadding: 0.6,
  triangleSpacer: { y: 6, x: 8 }
}